import { connect } from 'react-redux';
import { getDiscoverRegion } from 'state/discover/discover.selector';
import { discoverRegionChanged } from 'state/discover/page/page.actions';
import type { Region } from 'state/discover/page/page.model';
import { getUserPreferencesAvailableDiscoverPageRegions, getUserPreferencesTheme } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

interface WelcomePageOwnProps {}

interface WelcomePageStateProps {
  theme: SgBsTheme;
  region: Region;
  availableRegions: readonly Region[];
}
interface WelcomePageDispatchProps {
  onRegionChanged(region: Region): void;
}
export type WelcomePageProps = WelcomePageStateProps & WelcomePageDispatchProps;

export const mapStateToProps = (state: AppState, _: WelcomePageOwnProps): WelcomePageStateProps => {
  return {
    theme: getUserPreferencesTheme(state),
    region: getDiscoverRegion(state),
    availableRegions: getUserPreferencesAvailableDiscoverPageRegions(state),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): WelcomePageDispatchProps => {
  return {
    onRegionChanged(region) {
      dispatch(discoverRegionChanged(region));
    },
  };
};

export const connectWelcomePage = connect(mapStateToProps, mapDispatchToProps);
